export interface StandardPage {
  name: string;
  href: string;
}

export const HOME_PAGE: StandardPage = { name: 'Home', href: '/' };
export const ABOUT_US_PAGE: StandardPage = { name: 'About Us', href: '/about-us' };
export const CONTACT_US_PAGE: StandardPage = { name: 'Contact Us', href: '/contact-us' };

// Every website is expected to have these, in this order. Any page the website
// does not have yet is offered as an "Add Page" row instead.
export const STANDARD_PAGES: StandardPage[] = [HOME_PAGE, ABOUT_US_PAGE, CONTACT_US_PAGE];

export const IS_STANDARD_PAGE_HREF: Record<string, true> = {
  [HOME_PAGE.href]: true,
  [ABOUT_US_PAGE.href]: true,
  [CONTACT_US_PAGE.href]: true,
};
